import SectionTitle from "../../../../common/sectionTitle";
import data from "../../../../assets/data/services/features";
import FeaturesStyleWrapper from "./Features.style";
import FeaturesCard from "../featuresCard";

const Features = () => {
  return (
    <FeaturesStyleWrapper>
      <div className="team_sect v1_team_sect" id="team">
        <div className="v1_team_overlay">
          <div className="container">
            <SectionTitle title="The most trusted way for Powerfull Influence" subtitle="cryptocit features" />
            <div className="team_content">
              <div className="row">
                {data?.map((item, i) => (
                  <div key={i} className="col-lg-3 col-md-4 col-sm-6">
                    <FeaturesCard {...item} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </FeaturesStyleWrapper>
  );
};

export default Features;
